/**
 * Menu management routes
 */
export default [
    {
        path: '/menus',
        name: 'menus',
        component: () => import('@/views/menu/MenusPage.vue'),
        meta: {
            title: 'Menu Management',
            requiresAuth: true,
            roles: ['vendor', 'sponsor']
        }
    },
    {
        path: '/menu-items',
        name: 'menu.items',
        component: () => import('@/views/menu/MenuItemBasesPage.vue'),
        meta: {
            requiresAuth: true,
            title: 'Menu Items Catalog',
            roles: ['vendor', 'sponsor']
        }
    },
    {
        path: '/menus/:id',
        name: 'menu.show',
        component: () => import('@/views/menu/MenuShow.vue'),
        meta: {
            title: 'Menu Details',
            requiresAuth: true,
            roles: ['vendor', 'sponsor']
        }
    }
]
